import React from "react";
import { cn } from "@/lib/utils";

interface StepperStepProps {
  title: string;
  stage: string;
  allStagesInStep?: string[]; // Add optional array of all stages in this step
  currentStage: string;
  completedStages: string[];
  number: number;
}

const StepperStep: React.FC<StepperStepProps> = ({
  title,
  stage,
  allStagesInStep = [], // Default to empty array if not provided
  currentStage,
  completedStages,
  number,
}) => {
  // Check if this step is active (current)
  // A step is active if the current stage is either the primary stage or any of the stages in this step
  const isActive = currentStage === stage || 
    (allStagesInStep.length > 0 && allStagesInStep.includes(currentStage));
  
  // Check if this step is completed
  const isCompleted = completedStages.includes(stage);

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center justify-center">
        <div
          className={cn(
            "w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center text-xs md:text-sm font-medium border-2",
            isActive
              ? "bg-honeycomb border-honeycomb text-white"
              : isCompleted
              ? "bg-jungle border-jungle text-white"
              : "border-gray-300 text-gray-500"
          )}
        >
          {number}
        </div>
      </div>
      <div
        className={cn(
          "mt-1 md:mt-2 text-[10px] md:text-xs text-center max-w-[60px] md:max-w-none leading-tight",
          isActive
            ? "text-honeycomb"
            : isCompleted
            ? "text-jungle"
            : "text-gray-500"
        )}
      >
        {title}
      </div>
    </div>
  );
};

export default StepperStep;
